export const Workshop = {
  colors: {
    primary: '#0088aa',
    primaryLight: '#5E60CE',
    primaryDark: '#7400B8',
    secondary: '#1361A4',
    inheritDefault1: '#fefefe',
    inheritDefault2: '#f8f9ff',
    second: '#070919',
    indigo: '#7420ff',
    purple: '#793de6',
    pink: '#fc26a4',
    red: '#eb1748',
    orange: '#f4772e',
    yellow: '#ffc926',
    green: '#42a922',
    teal: '#18e1a5',
    cyan: '#27dcf3',
  },
};